import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { FIGMA_COLORS } from "components-redesign/styles";
import { COLORS_TO_BE_REVIEWED } from "components-redesign/styles/colors";
import React, { ChangeEvent } from "react";

const StyledCheckbox = styled((props: CheckboxProps) => (
  <MuiCheckbox
    focusVisibleClassName=".Mui-focusVisible"
    {...props}
  />
))(() => ({
  "&.MuiCheckbox-root": {
    color: COLORS_TO_BE_REVIEWED.neutral80,
    "&.Mui-disabled": {
      color: FIGMA_COLORS.onSurfaceLight,
      opacity: 0.38,
    },
    "&:hover": {
      backgroundColor: FIGMA_COLORS.surfaceContainerLowLight,
    },
  },
  "&.Mui-checked": {
    color: FIGMA_COLORS.primaryLight,
  },
  transition: "background-color 300ms linear",
}));

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  "&.MuiFormControlLabel-root": {
    gap: "15px", // its 24px but checkbox has 9px padding
    marginLeft: 0,
    marginRight: 0,
  },
}));

type IProps = {
  label?: string | React.ReactNode;
  checked: boolean | undefined;
  indeterminate?: boolean | undefined;
  onChange: (val: boolean) => void;
  disabled?: boolean;
  checkedComponent?: React.ReactNode;
  uncheckedComponent?: React.ReactNode;
};

const Checkbox: React.FC<IProps> = ({
  label,
  checked,
  indeterminate,
  onChange,
  disabled,
  checkedComponent,
  uncheckedComponent,
}) => {
  // Use custom components when provided, otherwise use default checkbox
  const renderControl: any = () => {
    if (checkedComponent && checked) {
      return checkedComponent;
    }
    if (uncheckedComponent && !checked) {
      return uncheckedComponent;
    }
    return (
      <StyledCheckbox
        checked={checked}
        indeterminate={indeterminate}
        onChange={(_e: ChangeEvent<HTMLInputElement>, checked: boolean) =>
          onChange(checked)
        }
        disabled={disabled}
      />
    );
  };

  const customComponent =
    (checkedComponent && checked) || (uncheckedComponent && !checked);

  if (customComponent) {
    return (
      <div
        onClick={() => !disabled && onChange(!checked)}
        style={{
          cursor: disabled ? "default" : "pointer",
          display: "flex",
          alignItems: "center",
          gap: "15px",
        }}>
        {renderControl()}
        {label}
      </div>
    );
  }

  return (
    <StyledFormControlLabel
      label={label}
      control={renderControl()}
    />
  );
};

export default Checkbox;
